import {
  AggregationOptions,
  Query,
  aggregate,
  customEndpoint,
  readItems,
} from "@directus/sdk";
import { GaripalliDirectusClient } from "../directus/client";
import { Props, PropsTransaction } from "../directus/collections";
import { Schema } from "../directus/schema";

export async function fetchProps(
  client: GaripalliDirectusClient,
  query?: Query<Schema, Props> | undefined
) {
  return client.request<Props[]>(readItems("props", query));
}

export async function fetchPropsTransaction(
  client: GaripalliDirectusClient,
  query?: Query<Schema, PropsTransaction>
) {
  return client.request<PropsTransaction[]>(
    readItems("props_transactions", query)
  );
}

export async function fetchTransactionAggregate<T>(
  client: GaripalliDirectusClient,
  options: AggregationOptions<Schema, "props_transactions">
): Promise<T> {
  const response = await client.request<T>(
    aggregate("props_transactions", options)
  );
  return response;
}

export async function fetchPropAvailability(
  directus: GaripalliDirectusClient,
  id: string
): Promise<{ status: string; available: boolean }> {
  const result = await directus.request<{
    status: string;
    available: boolean;
  }>(customEndpoint({ path: `/g/prop-availability/${id}`, method: "GET" }));

  return result;
}
